import { useKeystone } from "data/ss-data-hooks";
import { isError } from "data/ss-error";

export function usePaymentInfo() {
  const keystone = useKeystone();
  return {
    verify: async (policyId: string, zip: string) => {
      const res = await keystone.verifyPayment(policyId, zip);
      if (isError(res)) {
        let message =
          "There was an error while submitting. Please refresh your browser and try again.";
        if (res.name === "NotFoundError") {
          message =
            "We were unable to find a SageSure insurance policy with that combination of policy number and zip code. Please try again.";
        } else if (
          res.message.includes("is not valid for a commercial policy")
        ) {
          message =
            "10 Pay Payment Plan requires EasyPay enrollment. Please login or register an account to enroll in EasyPay and set up automatic payments.";
        }
        return {
          data: null,
          error: message,
        };
      }
      return {
        data: res,
        error: null,
      };
    },
  };
}
